export default __webpack_public_path__ + "static/media/dtmf-hash.1508413b.mp3";